import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, SuccessHttpResponse } from '../../../models/https';
import { ReviewAction, RiskAlertDetail } from '../../../models/risk/risk.model';
import useHttps from '../../useHttps';

const useRiskAlert = (alertId?: string) => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [alert, setAlert] = useState<RiskAlertDetail | null>(null);

  useEffect(() => {
    if (!alertId) return;
    request(
      { url: `api/v1/admin/risk/alerts/${alertId}`, method: 'get' },
      ({ data }: SuccessHttpResponse<RiskAlertDetail>) => setAlert(data),
      setLoading,
      (err: AxiosError<ErrorHttpResponse>) =>
        console.error(err?.response?.data?.message ?? 'Failed to load alert')
    );
    // eslint-disable-next-line
  }, [alertId]);

  const review = (action: ReviewAction, note: string, onDone?: () => void) => {
    if (!alertId) return;
    request(
      {
        url: `api/v1/admin/risk/alerts/${alertId}/review`,
        method: 'post',
        data: { action, note: note || null },
      },
      ({ data, message }: SuccessHttpResponse<RiskAlertDetail>) => {
        setAlert(data);
        toast.success(message);
        onDone?.();
      },
      setSaving,
      (err: AxiosError<ErrorHttpResponse>) =>
        toast.error(err?.response?.data?.message ?? 'Could not update the alert')
    );
  };

  return { alert, loading, saving, review };
};

export default useRiskAlert;
